angular.module('lf.common')

.controller('SubscriptionRestartMembershipCtrl', function ($scope, $injector, subscriptionService) {
  var client = lf.data.xhr.client;
  var isDesktop = client.isDesktop || client.isLFC;
  var modals = $injector.get(isDesktop ? 'popupsService' : 'slideinService');
  var popupsService = $injector.get(isDesktop ? 'popupsService' : '$popups');
  var membershipPageUrl = lf.data.xhr.siteBaseUrl + '/subscription/membership.jsp';
  
  $scope.subscriptionData = lf.data.subscriptionData;
  
  $scope.error = null;
  
  $scope.showUpdateCreditCardModal = function showUpdateCreditCardModal () {
    modals.show('update-credit-card');
  }
  
  $scope.isCardExpired = (function () {
    var card = lf.data.subscriptionData.paymentData.creditCards[0];
    var now = new Date();
    var currYear = now.getFullYear();
    var currMonth = now.getMonth() + 1;
    var expYear = +card.expires.year;
    var expMonth = +card.expires.month;
    
    return expYear < currYear || (expYear === currYear && expMonth < currMonth);
  })();
  
  $scope.restartMembership = function restartMembership () {
    
    if ($scope.isCardExpired) {
      popupsService.show('popup_card-is-expired');
      return;
    }
    
    $scope.showProcessingPopup();
    $scope.requesting = true;
    
    $scope.error = null;
    
    subscriptionService.restartMembership()
      .success(function (data) {
        if (data.success) {
          window.location = membershipPageUrl;
        } else {
          $scope.error = {};
          if (data && data.error && data.error.details) {
            $scope.error.message = data.error.details[0];
          } else {
            $scope.error.serverError = true;
          }
        }
      })
      .error(function () {
        $scope.error = { serverError: true };
      })
      .finally(function () {
        $scope.hideProcessingPopup();
        $scope.requesting = false;
      });
  }
  
});
